'use strict';

angular
    .module('App.v1.Controllers')
    .value('isSignedIn', typeof IsSignedIn !== 'undefined' && IsSignedIn || false)
    .value('viewmodel', ViewBag)
    .controller("App.v1.Root.Controller",
        ["$scope", "$log", "App.v1.Services.User", "App.v1.Services.DeploymentDetection", "isSignedIn", "viewmodel",
            function ($scope, $log, userService, deploymentDetectionService, isSignedIn, viewmodel) {

                // Initialize user promise before child controllers init
                $scope.vm = {
                    user: isSignedIn ? userService.get() : null,
                };

                $scope.tenantId = viewmodel.tenantId;
                $scope.tenantName = viewmodel.tenantName;

                /**
                 * Initialize the controller on page load
                 */
                this.$onInit = function () {

                    // Initialize deployment detection service with initial version from server
                    deploymentDetectionService.initialize(viewmodel.appVersion);

                    // Listen for deployment detected event
                    $scope.$on('deploymentDetected', function(event, newVersion) {
                        // Broadcast to child controllers
                        $scope.$broadcast('showDeploymentNotification', newVersion);
                    });
                };

                /**
                 * Clean up when scope is destroyed
                 */
                $scope.$on('$destroy', function() {
                    deploymentDetectionService.stop();
                    $log.info('Deployment Detection stopped');
                });
            }]);
